<template>
  <span>{{ display }}</span>
</template>

<script>
import { trailers } from "../../api/movementapi";

export default {
  props: {
    trailerId: String,
  },
  data() {
    return {
      trailer: null
    }
  },
  watch: {
    trailerId(newVal) {
      this.test();
    },
  },
  computed: {
    display() {
      return this.trailer != null ? this.trailer.note : "";
    }
  },
  methods: {
    test() {
      if(this.trailerId != null && this.trailerId != "ZZZZ") {
        trailers.findTrailer("QUCF", this.trailerId).then(res => {
          this.trailer = res.data.payload;
        }).catch(err => {
          this.trailer = null;
        })
      }
    },
  },
  mounted() {
    this.test();
  }
}
</script>

<style scoped />
